var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"disabled":_vm.disabled,"options":_vm.options},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }